import {EquipmentCardInterfaces, EquipmentInterfaces} from '@namespaces/equipment.namespace';

export namespace WizardInterfaces {
    export interface AttestationValue {
        key: string;
        title: string;
        methodId: number;
        objects: ObjectAttestation[];
        submethods: SubmethodAttestation[];
    }

    /**
     * Объект в области аттестации, например:
     * {id: 13, number: '2.1.1', parent_id: 7, title: 'Наружные газопроводы стальные'}
     */
    export interface ObjectAttestation {
        id: number;
        number: string;
        /**
         * Весь перечень номером объектов, которые соответствуют текущему.
         * Для объекта сюда включаеются его номер и номера всех его подобъектов.
         */
        realNumbers: string[];
        parent_id: number;
        title: string;
    }

    /**
     * Подметод области аттестации, например:
     * {id: 18, parent_id: 3, title: '"Гаммаграфический "'}
     */
    export interface SubmethodAttestation {
        id: number;
        parent_id: number;
        title: string;
    }

    /**
     * Группа с оборудованием на шаге оборудования в визарде.
     */
    export interface ApparatusStepGroup {
        id: number;
        title: string;
        equipment: EquipmentCardInterfaces.Card.ItemView[];    // Оборудование для группы
        required?: boolean;         // Требуется ли оборудование этой группы для успешной валидации
        valid?: boolean;            // Валидна ли текущая группа оборудования
        error_message?: string;      // Сообщение об ошибке, если группа не валидна
    }

    export interface StdDocument {
        id: number;
        method: string;             //
        method_id: number;          //
        number: string;             //
        object: string;             // Объекты области аттестации, к которым относится документ
        short_code: string;         // Код документа (например ГОСТ Р 52727-2007)
        title: string;
        type: number;
        year: string|number;
    }

    export interface CompliationData {
        title: string;
        objects: {
            [key: string]: {
                full: boolean;
                status: number;
            }
        };
        submetodsTitles: string[];
        choosenObjects: string[];
    }

    export interface EquipmentSearchResponce {
        page: number;
        pagesTotal: number;
        items: EquipmentInterfaces.Model[];
        total_items_count: number;
    }

    export interface EquipmentStorageData {
        groups: ApparatusStepGroup[];
        /**
         * Область аттестации, для которой задано оборудование
         */
        attestation: AttestationValue;
        method_id: number;
        /**
         * Имеется ли непромодерированное оборудование
         */
        has_not_moderated: boolean;
    }
}

export namespace WizardEnums {
    /**
     * Тип оборудования
     */
    export enum ApparatusTypes {
        apparatus,  // Оборудование
        examples    // Образцы и эталоны
    }

    /**
     * Тип лаборатории
     */
    export enum LaboratoryTypes {
        lnk = 1,    // ЛНК - лаборатория неразрушающего контроля
        lri = 2,    // ЛРИ
    }

    /**
     * Тип аттестации лаборабории. Атестовывать лабораторию как:
     */
    export enum LaboratoryAttestationTypes {
        new = 1,        // Новая
        existed = 2,    // Действующая
    }

    /**
     * Типы документации
     */
    export enum DocumentsTypes {
        sdank01 = 1,    // СДАНК-01-2020
        sda15 = 2,      // СДА15-2009
        transoil = 3,   // АО "АК "Транснефть"
        ronktd03 = 4,   // СНК ОПО РОНКТД-03-2021
    }

    /**
     * Тип подчинения руководителя лаборатории
     */
    export enum LaboratorySlaveTypes {
        organizationHead = 1,   // Подчиняется руководителю организации
        custom = 2              // Указывается самостоятельно
    }

    /**
     * Тип фактического адреса лаборатории
     */
    export enum LaboratoryRealAddressTypes {
        asOrganizationReal = 1,     // Как фактический адрес организации
        custom = 2,                 // Указывается самостоятельно
    }

    export enum WizardStepValidStatus {
        invalid,
        valid,
        undefined,
    }

    export enum Steps {
        organizationCommon = 1,
        organizationContacts,
        attestation,
    }
}




